<template>
	<div v-if="hidePage">
		<div style="display:flex;justify-content: space-between;">
			<div style="display:flex;">
				<h3>风机检测</h3>
				<img class="speed" src="@/assets/img/paifeng/风机检测.jpg" />
			</div>
			<div>
				<el-button type="primary" @click="showHistorical">查询历史</el-button>
			</div>
		</div>
		<el-dialog title="历史记录查询" :visible.sync="showDia" :close-on-click-modal="true" width="50%">
			<div class="content">
				<el-form ref="form" :model="form" label-width="80px">
					<div class="top" style="display: flex;justify-content: space-between;width: 100%;">
						<el-form-item label="设备编号:">
							<el-select v-model="searchQuery.deviceNo" placeholder="请选择设备编号" @change="searchQuery.pageNum = 0">
								<el-option :value="item.deviceNo" v-for="(item, index) in tableData" :key="index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="位置:">
							<el-select v-model="searchQuery.position" placeholder="请选择位置" @change="searchQuery.pageNum = 0">
								<el-option :value="item.position" v-for="(item, index) in tableData" :key="index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="historicalQuery">查询</el-button>
							<el-button type="primary" @click="Reset">重置</el-button>
						</el-form-item>
					</div>
					<div class="midden" style="display: flex;">
						<el-form-item label="开始时间:" prop="" style="width:100%" class="flex1">
							<el-date-picker
								v-model="searchQuery.startTime"
								type="datetime"
								placeholder="选择开始日期时间"
								value-format="yyyy-MM-dd HH:mm:ss"
								:default-time="'00:00:00'"
								@change="searchQuery.pageNum = 1"
							>
							</el-date-picker>
						</el-form-item>
						<el-form-item label="结束时间:" style="width:100%" class="flex1">
							<el-date-picker
								v-model="searchQuery.endTime"
								type="datetime"
								placeholder="选择结束日期时间"
								value-format="yyyy-MM-dd HH:mm:ss"
								:default-time="'23:59:59'"
								@change="searchQuery.pageNum = 1"
							>
							</el-date-picker>
						</el-form-item>
					</div>

					<div class="botoom">
						<el-table :data="searchList" style="width: 100%" border>
							<el-table-column type="index" label="编号" header-align="center" align="center" width="80px"> </el-table-column>
							<el-table-column prop="startTime" label="启动时间" header-align="center" align="center"> </el-table-column>

							<el-table-column prop="endTime" label="结束时间" header-align="center" align="center"> </el-table-column>

							<el-table-column header-align="center" align="center">
								<template slot="header">
									<span>平均风速</span>
									<img class="windImg" src="@/assets/img/wind_speed.png" />
								</template>
								<template slot-scope="scope">
									<span>{{ scope.row.avgWindSpeed + "米/秒" }}</span>
								</template>
							</el-table-column>
						</el-table>

						<el-pagination
							background
							layout="prev, pager, next,sizes,total"
							:current-page.sync="searchQuery.pageNum"
							@size-change="historicalQuery"
							@current-change="historicalQuery"
							:page-sizes="[10, 20]"
							:page-size.sync="searchQuery.pageSize"
							:total="searchTotal"
						>
						</el-pagination>
					</div>
				</el-form>
			</div>
		</el-dialog>
		<!-- 表格 -->
		<div class="table" style="margin: 30px ;">
			<el-table :data="tableData" style="width: 100%" border>
				<el-table-column type="index" label="编号" header-align="center" align="center" width="80px"> </el-table-column>
				<el-table-column prop="deviceNo" label="设备编号" header-align="center" align="center"> </el-table-column>

				<el-table-column label="位置" header-align="center" align="center">
					<template slot-scope="scope">
						<div v-show="!flag[scope.$index]" :key="isbutton">
							<span>{{ scope.row.position == null ? "暂无数据" : scope.row.position }}</span>
							<i style="margin-left: 20px;cursor: pointer;" class="el-icon-edit-outline" @click="edit(scope.row.id, scope.row, scope.$index)"></i>
						</div>
						<el-input v-show="flag[scope.$index]" @blur="sure(scope.$index, scope.row.id, scope.row)" v-model="scope.row.position" ref="inptVal"></el-input>
					</template>
				</el-table-column>

				<el-table-column header-align="center" align="center">
					<template slot="header">
						<span>风速</span>
						<img class="windImg" src="@/assets/img/wind_speed.png" v-if="tableData.state == null" />
					</template>
					<template slot-scope="scope">
						<span>{{ scope.row.windSpeed == null ? "暂无数据" : scope.row.windSpeed || "暂无数据" }}</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination
				background
				layout="prev, pager, next,sizes,total"
				:current-page.sync="query.pageNum"
				@size-change="getList"
				@current-change="getList"
				:page-sizes="[10, 20]"
				:page-size.sync="query.pageSize"
				:total="total"
			>
			</el-pagination>
		</div>
	</div>
</template>
<script>
	import { windlist, windSearchList } from "@/api/facility.js";
	import config from "../../utils/config.js";
	export default {
		props: ["cpNum"],
		data() {
			return {
				tableData: [],
				// 分页数据
				query: {
					pageNum: 1,
					pageSize: 10,
				},
				total: 0,
				flag: [], // 让修改按钮隐藏
				hidePage: false, // 隐藏页面
				isbutton: 0, // 找到对应的 key 值
				websock: null,
				auto: true,
				loading: true,
				showDia: false,

				defaultStartTime: "",
				defaultEndTime: "",
				form: {
					name: "",
					region: "",
				},
				searchList: [],
				searchQuery: {
					pageNum: 1,
					pageSize: 10,
					startTime: "", // 开始时间
					endTime: "", // 结束时间
					deviceNo: null, // 设备编号
					position: "", // 位置
				},
				searchTotal: 0,
			};
		},
		watch: {
			cpNum() {
				this.getList();
			},
		},
		created() {
			this.initWebSocket();
		},
		mounted() {
			if (this.cpNum) {
				this.getList();
			}
		},
		destroyed() {
			this.websock.close(); //离开路由之后断开websocket连接
		},
		methods: {
			// 修改
			edit(id, row, index) {
				log(id, row.position, index);
				this.isbutton++;
				this.flag[index] = true;
			},
			sure(index, id, row) {
				var obj = { deviceNo: row.deviceNo, id: id, position: row.position, type: row.type };
				this.flag[index] = false;
				// 请求接口
				this.$put(`/device/monitorDevice/editPosition`, obj).then((res) => {
					this.isbutton++;
					if (res.code == 200) {
						this.$message({message: res.msg,type: "success", duration: 700,});
					}
				});
			},
			// 分页
			handleSizeChange(val) {
				this.query.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				this.query.page = val;
				this.getList();
			},
			getList() {
				var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "93fe79c642aa44e182aa3c793dfc9b55" : this.cpNum;
				windlist({ companyNum: cNum, ...this.query }).then((res) => {
					console.log(res);
					this.tableData = res.rows;
					this.total = res.total;
					this.hidePage = true;
					if (res.rows.length) {
						this.searchQuery.deviceNo = res.rows[0]?.deviceNo;
						this.searchQuery.position = res.rows[0]?.position;
					}
					if (!res.rows.length) {
						this.hidePage = false;
						this.$message.warning("该业务尚未开通，请联系管理员");
					}
				});
			},
			initWebSocket() {
				let wsUrl = "";
				if (process.env.NODE_ENV == "development") {
					//本地
					wsUrl = config.wsUrltest;
				} else if (process.env.NODE_ENV == "production") {
					//线上
					wsUrl = config.wsUrl;
				}
				//初始化weosocket
				// const wsuri = "ws://47.105.170.47:8888/ws/mqt";
				// const wsuri = "ws://192.168.0.49:8899/ws/trweb";
				this.websock = new WebSocket(wsUrl);
				this.websock.onmessage = this.websocketonmessage;
				this.websock.onopen = this.websocketonopen;
				this.websock.onerror = this.websocketonerror;
				this.websock.onclose = this.websocketclose;
			},
			websocketonopen() {
				log("链接");
				//连接建立之后执行send方法发送数据
				let message = "fasong";
				this.websocketsend(JSON.stringify(message));
			},
			websocketonerror() {
				//连接建立失败重连
				this.initWebSocket();
			},
			websocketonmessage(e) {
				//数据接收
				const redata = JSON.parse(e.data);
				for (const iterator of redata) {
					if (iterator.type == "271" && iterator.wsType == 1)
						for (const item of this.tableData) {
							if (item.deviceNo == iterator.deviceNo) {
								item = Object.assign(item, iterator);
							}
						}
				}
			},
			websocketsend(Data) {
				//数据发送
				this.websock.send(Data);
			},
			Reset() {
				this.searchQuery.startTime = "";
				this.searchQuery.endTime = "";
				this.searchQuery.pageNum = 1;
				this.searchTotal = 0;
				this.searchList = [];
			},
			// getSearchList() {
			// 	var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "93fe79c642aa44e182aa3c793dfc9b55" : this.cpNum;
			// 	windSearchList({ companyNum: cNum, ...this.searchQuery }).then((res) => {
			// 		// console.log(res, "分机搜索");
			// 		this.searchList = res.data.data;
			// 		this.searchTotal = res.data.total;
			// 	});
			// },
			showHistorical() {
				this.showDia = true;
				this.historicalQuery();
			},
			historicalQuery() {
				var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "93fe79c642aa44e182aa3c793dfc9b55" : this.cpNum;
				windSearchList({ companyNum: cNum, ...Object.assign(this.searchQuery) }).then((res) => {
					// console.log(res, "分机搜索");
					this.searchList = res.data.data;
					this.searchTotal = res.data.total;
					this.searchQuery.pageNum = 1;
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.el-icon-edit-outline {
		font-size: 18px;
		font-weight: bold;
	}

	.wind_speed {
		width: 25px;
		height: 25px;
		margin-left: 10px;
		// transform: rotate3d(360deg);
		animation: turn 1s linear infinite;
	}

	.windImg {
		width: 25px;
		height: 25px;
		margin-left: 10px;
	}

	.turn {
		animation: turn 0.1s linear infinite;
	}

	/*
		turn : 定义的动画名称
		10s : 动画时间
		linear : 动画平滑
		infinite :使动画无限循环
		transform:rotate(旋转角度)
		%0:动画开始
		%100:动画结束
*/
	@keyframes turn {
		0% {
			transform: rotate(0deg);
		}

		20% {
			transform: rotate(-72deg);
		}

		40% {
			transform: rotate(-144deg);
		}

		60% {
			transform: rotate(-216deg);
		}

		80% {
			transform: rotate(-288deg);
		}

		100% {
			transform: rotate(-360deg);
		}
	}

	.page {
		margin-midden: 50px;
		margin-table: 50px;
	}

	.speed {
		width: 30px;
		height: 30px;
		margin-left: 10px;
	}

	.content {
		width: 100%;
		height: 100%;
	}
</style>
